import { PropType, defineComponent } from "vue";
import VueJsonViewer from "vue-json-viewer";

export default defineComponent({
  name: "sdk-json-viewer",
  components: {
    VueJsonViewer,
  },
  props: {
    json: {
      type: Object as PropType<any>,
    },
  },
});
